import React from 'react';

interface ISetbackProps {
	size?: string;
	className?: string;
}

export const Setback = ({ size = '24', className }: ISetbackProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 20 20" fill="none" className={`${className}`}>
			<path
				d="M11.0454 15.7225C12.1881 15.7225 13.3052 15.3837 14.2553 14.7488C15.2055 14.1139 15.946 13.2116 16.3833 12.1558C16.8206 11.1001 16.935 9.93836 16.7121 8.81758C16.4892 7.6968 15.9389 6.6673 15.1309 5.85927C14.3228 5.05123 13.2933 4.50095 12.1725 4.27801C11.0518 4.05508 9.89005 4.1695 8.8343 4.6068C7.77854 5.04411 6.87618 5.78466 6.24131 6.73481C5.60644 7.68496 5.26758 8.80204 5.26758 9.94477"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M3.71289 8.25977L5.0822 10.3683L7.19075 8.99901"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
